export default (request, entities, translators) => ({
  findAll(ids) {
  },
  find(id) {
  },
});
